import { faMinus } from "@jewlr/pro-regular-svg-icons/faMinus"
import { faPlus } from "@jewlr/pro-regular-svg-icons/faPlus"
import { Box, Flex } from "@jewlr/storybook/core"
import PropTypes from "prop-types"
import { useState } from "react"
import { Link } from "react-router-dom"
import styled from "styled-components"

import { SideMenuTitle, SideMenuSubTitle } from "areas/helpdesk/index"
import Expand from "components/ui/expand"
import FontAwesomeIcon from "components/ui/font-awesome-icon"

const SubElementContainer = styled(Box).attrs((props) => ({
  ...props.theme.helpdesk.subElementContainer,
}))``

const SubMenuElement = ({ collectionData, collectionId, expanded }) => {
  const [expandMenu, toggleMenu] = useState(expanded)
  const categoryIds = Object.keys(collectionData[collectionId].categories)
  return (
    <SubElementContainer>
      <Flex
        justifyContent="space-between"
        mb={1}
        mt={1}
        onClick={() => toggleMenu(!expandMenu)}
      >
        <SideMenuTitle>{collectionData[collectionId].name}</SideMenuTitle>
        <FontAwesomeIcon
          className="text-black"
          icon={expandMenu ? faMinus : faPlus}
        />
      </Flex>
      <Expand
        data-cy={`helpdesk-dropdownCategory-${collectionData[collectionId].name}`}
        show={expandMenu}
      >
        {categoryIds.map((categoryId, index) => (
          <SideMenuSubTitle
            as={Link}
            data-lc="submenu-element"
            key={`dropdownCategory_${index}`}
            to={`/helpdesk/${collectionId}/${categoryId}`}
          >
            {collectionData[collectionId].categories[categoryId].name}
          </SideMenuSubTitle>
        ))}
      </Expand>
    </SubElementContainer>
  )
}

SubMenuElement.propTypes = {
  collectionData: PropTypes.object,
  collectionId: PropTypes.string,
  expanded: PropTypes.bool,
}

export default SubMenuElement
